var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3058_8)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98438 16C4.56837 16 0.984375 12.408 0.984375 8L0.98745 7.77619C1.1061 3.46354 4.64322 0 8.98438 0C13.3924 0 16.9844 3.584 16.9844 8C16.9844 12.408 13.3924 16 8.98438 16ZM12.1844 6.41598C11.9444 6.18398 11.5684 6.18398 11.3364 6.42398L8.98435 8.78398L6.63235 6.42398C6.40035 6.18398 6.01635 6.18398 5.78435 6.41598C5.54435 6.65598 5.54435 7.03198 5.78435 7.26398L8.56035 10.056C8.67235 10.168 8.82435 10.232 8.98435 10.232C9.14435 10.232 9.29635 10.168 9.40835 10.056L12.1844 7.26398C12.3044 7.15198 12.3604 6.99998 12.3604 6.84798C12.3604 6.68798 12.3044 6.53598 12.1844 6.41598Z",
    fill: "#12233D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3058_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown3);
export default __webpack_public_path__ + "static/media/arrow-down3.decea37bca632c516fc58f74a6bc140e.svg";
export { ForwardRef as ReactComponent };